module.exports = __webpack_public_path__ + "img/1579385414.61a5416e.jpg";